function trimupcase(s){
    return s.toUpperCase().replace(" ","")
}
export default trimupcase


// WEBPACK FOOTER //
// ./src/utils/trimupcase.js